import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Table,
  TreeSelect,
  AutoComplete
} from "antd";
import React from "react";
import { DownloadOutlined, SearchOutlined } from "@ant-design/icons";
import moment from "moment";

const { RangePicker } = DatePicker;
const rangeConfig = {
  rules: [
    {
      type: "array",
      required: true,
      message: "Vui lòng chọn thời gian!",
    },
  ],
};

const RecruitmentRequirements = ({
  form,
  listStatus,
  listUserReceived,
  listUserHR,
  listWorkLocation,
  // onChangeBP,
  currentBP,
  // treeDataBP,
  // treeData,
  columns,
  dataRecruitment,
  setRangeDate,
  onFinish,
  tPropsConfig_BoPhan,
  dateSearch,
  fileDownloadRecr,
  pager,
  handleChange
}) => {
  return (
    <div>
      <Form
        form={form}
        layout="vertical"
        autoComplete="off"
        onFinish={onFinish}
        // onFinishFailed={onFinishFailed}
        // validateMessages={validateMessages}
        // loading={loading}
        initialValues={{
          remember: true,
        }}
      >
        <Row className="recruitment-requirements-row">
          <Col span={4}>
            <Form.Item
              label="Thời gian"
              name="datepicker"
              className="recruitment-requirements-form-item"
              {...rangeConfig}
              tooltip="Thời gian khi Ticket đã duyệt"
            >
              <RangePicker
                ranges={{
                  "Hôm nay": [moment(), moment()],
                  "Tháng này": [
                    moment().startOf("month"),
                    moment().endOf("month"),
                  ],
                  "Năm nay": [moment().startOf("year"), moment().endOf("year")],
                  "Năm ngoái": [
                    moment().add(-1, "year").startOf("year"),
                    moment().add(-1, "year").endOf("year"),
                  ],
                }}
                format="DD/MM/YYYY"
                defaultValue={dateSearch}
                onChange={(dates) => setRangeDate(dates)}
                allowClear={false}
                // onOpenChange={(e) => handleOpenDateChange(e)}

              />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              label="Bộ phận tuyển dụng"
              name="department_recruited"
              className="recruitment-requirements-form-item"
            >
              {currentBP && <TreeSelect {...tPropsConfig_BoPhan} />}

              {/* <TreeSelect
                treeData={treeData}
                value={treeDataBP.length > 0 ? currentBP : undefined}
                onChange={onChangeBP}
                treeCheckable={true}
                // showCheckedStrategy={"SHOW_PARENT"}
                maxTagCount={2}
                placeholder={"Chọn bộ phận"}
                clearIcon
              /> */}
            </Form.Item>
          </Col>
          {/* <Col span={4} >
            <Form.Item
              label="Địa điểm làm việc"
              name="work_location"
              className="recruitment-requirements-form-item"
            >
              <Input placeholder="Nhập địa điểm"></Input>
            </Form.Item>
          </Col> */}
          <Col span={3}>
            <Form.Item
              label="Người xử lý"
              name="user_received"
              className="recruitment-requirements-form-item"
            >
              {/* <Select allowClear={true} placeholder="Chọn người xử lý">
                {listUserReceived.map((value) => (
                  <Select.Option key={value.id} value={value.id}>
                    {value.username}
                  </Select.Option>
                ))}
              </Select> */}
              {/* <Input placeholder="Nhập username"></Input> */}
              <Input.Group compact>
                  <AutoComplete
                    style={{ width: "100%" }}
                    placeholder="Nhập username"
                    onChange={(value) => {
                      form.setFieldsValue({ user_received: value });
                    }}
                  >
                    {listUserHR.map((item) => (
                      <AutoComplete.Option key={item.id} value={item.username}>
                        {item.username}
                      </AutoComplete.Option>
                    ))}
                  </AutoComplete>
                </Input.Group>
            </Form.Item>
          </Col>

          <Col span={3}>
            <Form.Item
              label="Trạng thái yêu cầu"
              name="ticket_status"
              className="recruitment-requirements-form-item"
            >
              <Select
                allowClear={true}
                placeholder="Chọn trạng thái"
                // onChange={handleChangeProfileStatus}
              >
                {listStatus.map((profile_status) => (
                  <Select.Option
                    key={profile_status.id}
                    value={profile_status.id}
                  >
                    {profile_status.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item
              label="Tiêu đề"
              className="recruitment-requirements-form-item"
              name="title"
            >
              <Input placeholder="Nhập tiêu đề"></Input>
            </Form.Item>
          </Col>

          <Col span={1} className="recruitment-requirements-span-2">
            <Form.Item label={" "}>
              <Button
                type="primary"
                className="recruitment-requirements-button big-icon"
                htmlType={"submit"}
              >
                <SearchOutlined />
              </Button>
            </Form.Item>
          </Col>
          <Col span={1} className="recruitment-requirements-span-2">
            <Form.Item label={" "}>
              <Button
                type={"primary"}
                className={"recruitment-requirements-button btnGreen big-icon"}
                style={{ marginRight: 5, float: "right" }}
                onClick={fileDownloadRecr}
                icon={<DownloadOutlined />}
              >
                Tải xuống
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <Row className="recruitment-requirements-row">
        <Table
          className="recruitment-requirements-table"
          columns={columns}
          dataSource={dataRecruitment}
          scroll={{
            x: 768, // Kích thước ngang tự động điều chỉnh theo nội dung cột
            y: "62vh", // Chiều cao tối đa có thể lăn (thay số này để phù hợp với màn hình)
          }}
          onChange={handleChange}

          pagination={{
            current: pager.current,
            pageSize: pager.pageSize,
            total: pager.count,
            showSizeChanger: true,
            showQuickJumper: false,
            pageSizeOptions: ["10", "50", "100", "150"],
          }}
        />
      </Row>
    </div>
  );
};

export default RecruitmentRequirements;
